<template>
  <div class="item-container">
    <TourHeader
      :tour-hub-item="tourHubItem"
      :country-content="countryContent"
      @clicked="toggleExpand" 
    />
    <div 
      v-if="dropdown" 
      class="item-dropdown"
    >
      <div class="item-dropdown-container">
        <BodyTop :tourHubItem="tourHubItem" :country-content="countryContent" />
        <BodyBottom :tourHubItem="tourHubItem" :forceClosePrivateTour="forceClosePrivateTour" :country-content="countryContent" @toggle-th-show-all="$emit('toggle-th-show-all', $event)"/>
      </div>
    </div>
  </div>   
</template>
   
<script>
import TourHeader from './header.vue'
import BodyTop from './body-top.vue'
import BodyBottom from './body-bottom.vue'


export default {
  components: {
    TourHeader,
    BodyTop,
    BodyBottom
  },
  props: {
    tourHubItem: {
      type: Object,
      default: null
    },
    tourHubCountryData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      dropdown: true,
      itineraryBlocks: true,
      forceClosePrivateTour: false,
    }
  },
  computed: {
    countryContent() {
      let output = {
        title: '',
        tourStyle: 'PRIVATE TOUR',
        iconName: 'image_search'
      }
      if (
        this.tourHubCountryData
      ) {
        const tourId = this.tourHubItem._id;
        const match = this.tourHubCountryData.find((el) => el.mainBookingId === tourId)
        if (match) {
          output = match;
        }
      }
      return output
    },
  },
  mounted () {
    this.$root.$on("collapseall", () => {
      this.collapseAll();
    });
    this.$root.$on("expandall", () => {
      this.expandAll();
    });
  },
  methods: {
    toggleExpand(value) {
      if (!value){
        this.forceClosePrivateTour = true;
      } else {
        this.forceClosePrivateTour = false;
      }
      setTimeout(() => {
        this.dropdown = value;
      }, 1)
    },
    expandAll() {
      this.dropdown = true;
    },
    collapseAll() {
      this.dropdown = false;
    },
  },
  // mounted () {
  //     this.$root.$on('toggleShowTouringItinerary', () => {this.itineraryBlocks = false} )
  //   },
};
</script>

<style lang="scss">
@import "../../styles.scss";
.item-dropdown-container {
  padding: 40px;
}
</style>
